/**
 * @file Basic select element.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from './Label';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelNote: PropTypes.string,
  labelTip: PropTypes.string,
  labelSrOnly: PropTypes.bool,
  labelType: PropTypes.oneOf(['standard', 'expanded']),
  className: PropTypes.string,
  selectClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  note: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inputRef: PropTypes.func,
  inline: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'xs']),
  required: PropTypes.bool,
};

const Select = ({
  id,
  className,
  selectClassName,
  label,
  labelNote,
  labelTip,
  labelSrOnly,
  labelType,
  children,
  inputRef,
  note,
  inline,
  size,
  required,
  ...props
}) => {
  const classes = classNames({
    'form-group': true,
    'form-group-inline': inline,
    [className]: !!className,
  });

  const selectClasses = classNames({
    'form-control': true,
    'form-control-inline': inline,
    [`form-control-${size}`]: !!size,
    [selectClassName]: !!selectClassName,
  });

  return (
    <div className={classes}>
      {label && (
        <Label
          id={id}
          label={label}
          labelNote={labelNote}
          labelTip={labelTip}
          labelSrOnly={labelSrOnly}
          labelType={labelType}
          required={required}
          size={size}
        />
      )}

      <select
        id={id}
        className={selectClasses}
        ref={inputRef}
        required={required}
        {...props}
      >
        {children}
      </select>
      {note}
    </div>
  );
};

Select.propTypes = propTypes;

export default Select;
